import { translateWorkspaceText } from "@/locales/workspaceExtras";

const CODES = new Set(["PROFORMA_INVOICE", "COMMERCIAL_INVOICE", "PACKING_LIST", "SPA"]);
const COPY = {
  en: ["DRAFT — review and complete before sending or signing.", "TO BE COMPLETED", "Additional information"],
  ru: ["ЧЕРНОВИК — проверьте и заполните перед отправкой или подписанием.", "ЗАПОЛНИТЬ", "Дополнительная информация"],
  it: ["BOZZA — verificare e completare prima di inviare o firmare.", "DA COMPLETARE", "Informazioni aggiuntive"],
  de: ["ENTWURF — vor Versand oder Unterzeichnung prüfen und vervollständigen.", "AUSZUFÜLLEN", "Zusätzliche Angaben"],
  es: ["BORRADOR — revisar y completar antes de enviar o firmar.", "POR COMPLETAR", "Información adicional"],
  zh: ["草稿 — 发送或签署前请审核并补全。", "待填写", "补充信息"],
};

// Offline manual drafts preserve supplied facts and expose missing required fields.
// Financial totals and package weights are never inferred here.
export function buildCoreTradeDocument(template, values, language, title, extra = []) {
  if (!CODES.has(template?.code)) return null;
  const [notice, missing, extraTitle] = COPY[language] || COPY.en;
  const tr = (text) => translateWorkspaceText(language, text);
  const lines = [`# ${title || tr(template.title)}`, "", notice, ""];
  for (const section of template.sections || []) {
    const fields = (section.fields || []).filter((f) => {
      const value = values[`${section.key}_${f.name}`];
      return f.required || (value !== null && value !== undefined && String(value).trim() !== "");
    });
    if (!fields.length) continue;
    lines.push(`## ${tr(section.title)}`, "");
    for (const field of fields) {
      const value = values[`${section.key}_${field.name}`];
      const text = value !== null && value !== undefined && String(value).trim() !== ""
        ? String(value) : `[${missing}: ${tr(field.label)}]`;
      lines.push(`**${tr(field.label)}:** ${text}`, "");
    }
  }
  const additional = extra.filter((entry) => entry.key?.trim());
  if (additional.length) {
    lines.push(`## ${extraTitle}`, "");
    additional.forEach(({ key, value }) => lines.push(`**${key}:** ${value || ""}`, ""));
  }
  return lines.join("\n");
}
